import * as React from 'react';
import Box from '@mui/material/Box';
import { BarChart } from '@mui/x-charts';
import { black, gold } from '../../../../getLPTheme';
import { options } from '@config';

function widthSelect() {
  const widthScreen = document.body.clientWidth;
  if (widthScreen < 600) {
    return 340;
  } else {
    return 400;
  }
}

type MonthMetric = {
  label: string;
  count: number;
};

export default function GraficoAltaBaja() {
  const [data, setData] = React.useState<MonthMetric[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const res = await fetch(
          `${options.api.url}metrics/users/signups-12m`
        );
        const json = await res.json();

        const months = (json?.months || []).map((m: any) => ({
          label: m.label,
          count: m.count,
        }));

        setData(months);
      } catch (err) {
        console.error("Error loading metrics:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);

  if (loading || data.length === 0) {
    return <Box sx={{ color: black[900] }}>Cargando métricas...</Box>;
  }

  return (
    <Box>
      <BarChart
        xAxis={[
          {
            scaleType: "band",
            data: data.map((m) => m.label),
            tickLabelStyle: {
              fill: black[900],
              fontSize: 12,
            },
          },
        ]}
        series={[
          {
            data: data.map((m) => m.count),
            label: "Altas de usuarios",
            color: gold[500],
          },
        ]}
        width={widthSelect()}
        height={widthSelect() - 100}
        grid={{ horizontal: true }}
      />
    </Box>
  );
}
